module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-1.aafa219a.png";